import {SurveySubjectTypes, SurveyUseCase} from "~src/interfaces/surveys.interfaces";

export function getFormattedSubjectAndUseCaseTranslationKey(survey: {subject: SurveySubjectTypes, useCase: SurveyUseCase|undefined}) {
  switch (survey.subject) {
    case SurveySubjectTypes.People:
      switch (survey.useCase) {
        case SurveyUseCase.ThreeSixty: return 'x.surveys.list.details.item.type.people.three_sixty';
        case SurveyUseCase.BottomUp:  return 'x.surveys.list.details.item.type.people.bottom_up';
        case SurveyUseCase.TopDown: return  'x.surveys.list.details.item.type.people.top_down';
        default: throw new Error('unexpected useCase in ' + JSON.stringify(survey));
      }
    case SurveySubjectTypes.Groups: return 'x.surveys.list.details.item.type.groups';
    case SurveySubjectTypes.General: return 'x.surveys.list.details.item.type.general';
    default: throw new Error('unexpected subject in ' + JSON.stringify(survey));
  }
}
